import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import router, { ROUTE_NAME_BONUS } from './router';

menuRegistry.registerMenu([
    {
        parent: 'Multiplayer',
        key: 'Bonus',
        name: 'Bonus',
        icon: 'fas fa-gift'
    },
    {
        parent: 'Multiplayer.Bonus',
        key: 'Login',
        name: 'Login',
        icon: 'fas fa-sign-in-alt',
        route: { name: ROUTE_NAME_BONUS.LOGIN.INDEX }
    },
    {
        parent: 'Multiplayer.Bonus',
        key: 'Boost',
        name: 'Boost',
        icon: 'fas fa-angle-double-up',
        route: { name: ROUTE_NAME_BONUS.BOOST }
    }
]);

export default registerRouteForModule(router);
